import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { S25ItemI } from "../../../pojo/S25ItemI";
import { S25Util } from "../../../util/s25-util";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { EventService } from "../../../services/event.service";
import { MultiselectModelI } from "../../s25-multiselect/s25.multiselect.component";

@TypeManagerDecorator("s25-ng-editable-additional-orgs")
@Component({
    selector: "s25-ng-editable-additional-orgs",
    template: ` @if (init) {
        @for (org of addtlOrgs; track org) {
            <div class="s25-item-org-container">
                <s25-item-organization
                    [modelBean]="{ itemId: +org.itemId, itemName: org.itemName }"
                    [includeTypeIcon]="true"
                ></s25-item-organization>
                @if (editable) {
                    <button (click)="removeOrg(+org.itemId)" class="c-textButton">
                        <s25-ng-icon [type]="'close'"></s25-ng-icon>
                    </button>
                }
            </div>
        }
        @if (editable) {
            <s25-ng-multiselect-search-criteria
                [type]="'organizations'"
                [popoverOnBody]="true"
                [(modelBean)]="multiSelectBean"
                [selectedItems]="addtlOrgs"
                (onDone)="saveOrgs()"
            ></s25-ng-multiselect-search-criteria>
        }
    }`,
    styles: `
        :host {
            display: flex;
            flex-wrap: wrap;
            gap: 1em;

            .c-textButton {
                color: unset !important;
            }

            .s25-item-org-container {
                position: relative;
                display: flex;

                s25-item-organization {
                    position: relative;
                    top: 2px;
                }

                &:hover {
                    cursor: pointer;
                }
            }

            s25-ng-multiselect-search-criteria {
                flex-basis: 100%;
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EditableAdditionalOrgsComponent implements OnInit {
    @Input() itemId: number;
    @Input() addtlOrgs: S25ItemI[] = [];
    @Input() editable: boolean;

    init: boolean = false;
    multiSelectBean: MultiselectModelI = {};

    constructor(private cd: ChangeDetectorRef) {}

    ngOnInit() {
        this.addtlOrgs ??= [];
        this.sortOrgsAlphabetically();
        this.init = true;
    }

    async saveOrgs() {
        const { addedItems, removedItems } = this.multiSelectBean;
        if (!addedItems?.length && !removedItems?.length) return;
        const [_, err] = await S25Util.Maybe(
            EventService.updateOrganizations(
                [this.itemId],
                addedItems?.map((org) => org.itemId) ?? [],
                removedItems?.map((org) => org.itemId) ?? [],
            ),
        );
        if (err) return console.error(err);
        this.sortOrgsAlphabetically();
        this.cd.markForCheck();
    }

    async removeOrg(orgId: number) {
        const [_, err] = await S25Util.Maybe(EventService.updateOrganizations([this.itemId], [], [orgId]));
        if (err) return console.error(err);
        this.addtlOrgs = this.addtlOrgs.filter((el: S25ItemI) => el.itemId !== orgId);
        this.multiSelectBean.selectedItems = this.addtlOrgs;
        this.cd.markForCheck();
    }

    sortOrgsAlphabetically() {
        this.addtlOrgs.sort((a, b) => a.itemName.localeCompare(b.itemName));
    }
}
